import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Pillars } from "@/components/Pillars";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-sand">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Pillars />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
